// extracted by mini-css-extract-plugin
export default {"imagedimesion":"Cvloader_imagedimesion__bIUeR","divstyle":"Cvloader_divstyle__agQt6","MuiDialog-paperWidthSm":"Cvloader_MuiDialog-paperWidthSm__K38Um"};